<template>
  <section v-if="showSection && posts.length > 0" class="featured-posts-section-wrapper py-5">
    <div class="container-fluid">
      <!-- Loading State -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Φόρτωση άρθρων...</span>
        </div>
        <p class="text-muted mt-2">Φόρτωση άρθρων...</p>
      </div>

      <!-- Posts Content -->
      <div v-else class="row">
        <div class="col-12">
          <div class="featured-posts-section" data-aos="fade-up">
            <!-- Section Header -->
            <div class="text-center mb-5">
              <h2 class="posts-title">
                <i class="bi bi-file-text me-2"></i>
                {{ sectionTitle }}
              </h2>
              <p class="posts-subtitle text-muted">
                {{ sectionSubtitle }}
              </p>
            </div>

            <!-- Posts Grid -->
            <div class="posts-grid">
              <div class="row g-4">
                <div 
                  v-for="(post, index) in posts" 
                  :key="post.id"
                  class="col-lg-3 col-md-6"
                  data-aos="fade-up"
                  :data-aos-delay="index * 100"
                >
                  <BlogPostCard
                    :post="post"
                    view-mode="grid"
                    :is-in-wishlist="isInWishlist(post.id)"
                    @toggle-wishlist="$emit('toggleWishlist', post)"
                  />
                </div>
              </div>
            </div>

            <!-- View All Posts Button -->
            <div class="text-center mt-4">
              <router-link 
                to="/blog" 
                class="btn btn-primary"
              >
                <i class="bi bi-collection me-2"></i>
                Δείτε όλα τα άρθρα
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import BlogPostCard from '@/components/BlogPostCard.vue'

interface Post {
  id: number
  title: string
  slug: string
  excerpt: string
  featured_image: string
  category_name: string
  created_at: string
  views: number
  // Optional properties for compatibility
  content?: string
  category_id?: number | null
  gallery_images?: string[]
  tags?: string[]
  status?: 'published' | 'draft' | 'archived'
  featured?: boolean
  meta_title?: string
  meta_description?: string
  updated_at?: string
}

interface Props {
  showSection: boolean
  posts: Post[]
  loading?: boolean
  sectionTitle?: string
  sectionSubtitle?: string
  wishlistIds?: number[]
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  sectionTitle: 'Τελευταία Άρθρα',
  sectionSubtitle: 'Ανακαλύψτε τα πιο πρόσφατα νέα και άρθρα μας',
  wishlistIds: () => []
})

defineEmits<{
  toggleWishlist: [post: any]
}>()

const isInWishlist = (postId: number): boolean => {
  return props.wishlistIds.includes(postId)
}
</script>

<style scoped>
.featured-posts-section-wrapper {
  background: #f8f9fa;
}

.posts-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.posts-subtitle {
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .posts-title {
    font-size: 1.75rem;
  }
}
</style>
